import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"
import { FaUsers, FaChevronRight } from "react-icons/fa"
import axios from "axios"
import { localserver } from "../../../api/common"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"
import Admin from "./Admin"
import Manager from "./Manager"
import Support from "./Support"
import { useUser } from '../../AdminUsers/UserContext';

const RolesAndPermissions = () => {
  const { checkPermission } = useUser();
  const [activePage, setActivePage] = useState("admin")

  const topics = [
    { id: "admin", label: "Admin", icon: <FaUsers size={18} />, description: "" },
    { id: "manager", label: "Manager", icon: <FaUsers size={18} />, description: "" },
    { id: "support", label: "Support", icon: <FaUsers size={18} />, description: "" },
  ]
  const [formState, setFormState] = useState({
    eventTitle: false,
    eventLog: false,
    Posts: false,
    CommentsReplies: false,
    Spaces: false,
    Reviews: false,
    Roles: false,
    Admin: false,
    Community: false,
    Billing: false,
    Reports: false,
    registrationTitle: "",
    eventBanner: false,
    customTheme: false,
    backgroundOption: "abstract",
    selectedColor: "#ffffff",
    selectedGradient: "linear-gradient(90deg, #aabbcc, #ddeeff)",
    selectedBackgroundImage: null,
    primaryColor: "#007bff",
    displayEventPolicies: false
  })
  const handleFormChange = (field, value) => {
    setFormState((prevState) => ({
      ...prevState,
      [field]: value
    }))
  }

  const [rolesAndPermissionData, setRolesAndPermissionData] = useState([])

  useEffect(() => {
    getRolesAndPermission()
  }, [activePage])

  const getRolesAndPermission = async () => {
    try {
      const response = await axios.post(`${localserver}/get_user_permissions`,{
        id:activePage==="admin"?2:activePage==="manager"?3:4
      },{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
      })
      if (response.data.success) {
        setRolesAndPermissionData(response.data.data)
      } else {
        console.error("Error: Failed to fetch user data")
        showToast("Failed to fetch events", "error")
      }
    } catch (error) {
      console.error("Error fetching events:", error)
      showToast("An error occurred while fetching events", "error")
    }
  }
 // Check Admin User Permission
 const [checkUserLoading, setCheckUserLoading] = useState(false); 
 const fetchPermission = async () => {
   setCheckUserLoading(true);
   try {
     const hasPermission = await checkPermission("Roles & Permissions", "view");
     if (!hasPermission) return;
   } catch (error) {
     console.error("Error Check Permission:", error);
   }finally{
     setCheckUserLoading(false);
   }
 };
 useEffect(() => {
   fetchPermission();
 }, []);

  const renderHeader = () => (
    <div style={{ marginBottom: "22px" }}>
      <div
        className="brood_comes_div"
      >
        <div className="row align-items-center">
          <div className="col-md-6 brood_comes_heading">
            <h2  >
              <div className="brood_comes_part">
                <FaUsers size={20} />
              </div>
              Roles & Permission
            </h2>
          </div>

          <div className="col-md-6 text-end">
          </div>
        </div>
      </div>
    </div>
  )

  const renderNavigationTabs = () => (
    <div style={styles.navigationWrapper}>
      <div style={styles.navigationContainer}>
        <div style={styles.tabsWrapper}>
          {topics.map((topic) => (
            <button
              key={topic.id}
              style={{
                ...styles.tabItem,
                ...(activePage === topic.id ? styles.tabItemActive : {}),
              }}
              onClick={() => setActivePage(topic.id)}
            >
              <div
                style={{
                  ...styles.tabItemIcon,
                  ...(activePage === topic.id ? styles.tabItemIconActive : {}),
                }}
              >
                {topic.icon}
              </div>
              <div style={styles.tabItemContent}>
                <span
                  style={{
                    ...styles.tabItemTitle,
                    ...(activePage === topic.id ? styles.tabItemTitleActive : {}),
                  }}
                >
                  {topic.label}
                </span>
                <span
                  style={{
                    ...styles.tabItemDescription,
                    ...(activePage === topic.id ? styles.tabItemDescriptionActive : {}),
                  }}
                >
                  {topic.description}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  )

  const renderMainContent = () => (
    <div style={styles.contentWrapper}>
      <div style={styles.contentContainer}>
        {activePage === "admin" && (
          <div style={styles.pageContent}>
            <div style={styles.pageHeader}>
              <h2 style={styles.pageTitle}>Admin</h2>
            </div>
            <Admin
              rolesAndPermissionData={rolesAndPermissionData}
              handleFormChange={handleFormChange}
              setFormState={setFormState}
              formState={formState}
            />
          </div>
        )}
        {activePage === "manager" && (
          <div style={styles.pageContent}>
            <div style={styles.pageHeader}>
              <h2 style={styles.pageTitle}>Manager</h2>
            </div>
            <Manager
              rolesAndPermissionData={rolesAndPermissionData}
              handleFormChange={handleFormChange}
              setFormState={setFormState}
              formState={formState}
            />
          </div>
        )}
        {activePage === "support" && (
          <div style={styles.pageContent}>
            <div style={styles.pageHeader}>
              <h2 style={styles.pageTitle}>Support</h2>
            </div>
            <Support
              rolesAndPermissionData={rolesAndPermissionData}
              handleFormChange={handleFormChange}
              setFormState={setFormState}
              formState={formState}
            />
          </div>
        )}
      </div>
    </div>
  )

  return (
    <>
    {checkUserLoading? (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
          <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
          </div>
      </div>
  ) : ( 
    <div style={styles.appContainer}>
      <ToastMessage />
      {renderHeader()}
      {renderNavigationTabs()}
      <div style={styles.mainLayout}>{renderMainContent()}</div>
    </div>)}  
   </>
  )

}

const styles = {
  appContainer: {
    minHeight: "100vh",
    backgroundColor: "#f8fafc",
    padding: "24px",
  },
  headerWrapper: {
    marginBottom: "16px",
  },
  headerContainer: {
    margin: "0 auto",
    padding: "0 2rem",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    borderRadius: "12px",
  },
  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1.5rem 0",
  },
  headerLeft: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
  titleSection: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  mainTitle: {
    fontSize: "2rem",
    fontWeight: "700",
    color: "#1f2937",
    margin: 0,
    lineHeight: "1.2",
  },
  breadcrumbNav: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    fontSize: "0.875rem",
  },
  breadcrumbLink: {
    color: "#184778",
    textDecoration: "none",
    fontWeight: "500",
    transition: "color 0.2s ease",
  },
  breadcrumbSeparator: {
    color: "#9ca3af",
    fontSize: "1rem",
  },
  breadcrumbCurrent: {
    color: "#6b7280",
  },
  navigationWrapper: {
    marginBottom: "24px",
  },
  navigationContainer: {
    margin: "0 auto",
    padding: "0 2rem",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    borderRadius: "12px",
  },
  tabsWrapper: {
    display: "flex",
    gap: "0.5rem",
    padding: "1.5rem 0",
  },
  tabItem: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    padding: "5px 20px",
    backgroundColor: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textAlign: "left",
    minHeight: "65px",
  },
  tabItemActive: {
    backgroundColor: "#184778",
    borderColor: "#184778",
    color: "#ffffff",
    boxShadow: "0 4px 6px -1px rgba(24, 71, 120, 0.3)",
    transform: "translateY(-2px)",
  },
  tabItemIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    backgroundColor: "#e2e8f0",
    color: "#64748b",
    transition: "all 0.3s ease",
    flexShrink: 0,
  },
  tabItemIconActive: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    color: "#ffffff",
  },
  tabItemContent: {
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
    flex: 1,
  },
  tabItemTitle: {
    fontSize: "0.875rem",
    fontWeight: "600",
    color: "#374151",
    transition: "color 0.3s ease",
  },
  tabItemTitleActive: {
    color: "#ffffff",
  },
  tabItemDescription: {
    fontSize: "0.75rem",
    color: "#9ca3af",
    transition: "color 0.3s ease",
  },
  tabItemDescriptionActive: {
    color: "rgba(255, 255, 255, 0.8)",
  },
  mainLayout: {
    display: "flex",
    gap: "24px",
    alignItems: "flex-start",
  },
  contentWrapper: {
    flex: 1,
  },
  contentContainer: {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    overflow: "hidden",
  },
  pageContent: {
    padding: "2rem",
  },
  pageHeader: {
    marginBottom: "2rem",
    paddingBottom: "1.5rem",
    borderBottom: "1px solid #e5e7eb",
  },
  pageTitle: {
    fontSize: "1.5rem",
    fontWeight: "700",
    color: "#1f2937",
    margin: "0 0 0.5rem 0",
  },
}

export default RolesAndPermissions